<template>
  <div class="proWhy4 reveal px-10vw __scroll-clip">
    <div class="topwhy el-size--medium">
        <!-- <div class="fnH1">{{getTitle()}}</div> -->
        <h3>{{getTitle()}}</h3>
        <p>{{getContent()}}</p>
    </div>
    <!-- <span style="color:blue">{{dataItems}}</span> -->
    <ul>
        <li v-for="item in dataItems" :key="item.title" class="___scroll-clip why-scrollbox">
            <div class="scroll-thumb">
                <div class="image-wrapper">
                    <img :src="getImgUrl(item.file_url)"  :title="item.title" />                
                </div>
            </div>
            <div class="wElementText el-size--medium">
              <h3>{{item.title}}</h3>
              <p>{{item.description}}</p>
<!--               <h5>{{item.title}}</h5>
              <p>{{item.description}}</p>
 -->            </div>

        </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        testItems:[
            {file_url:"https://mis-lynx.mis-implants.com/lynx/img/lynx_feat1b.png",title:"Adaptive Placement for Surgical Simplicity *",description:"MIS LYNX’s distinctive design promotes flexibility and reliability in implant procedures."},
            {file_url:"https://mis-lynx.mis-implants.com/lynx/img/lynx_feat2.png",title:"Single-Use Drills with Every Implant for Surgical Efficiency *",description:"MIS LYNX includes sharp and sterile drills in every package, providing a simplified drilling procedure while maintaining strict hygiene protocols."},
            {file_url:"https://mis-lynx.mis-implants.com/lynx/img/lynx_feat3.png",title:"Restorative Versatility for Esthetics Excellence *",description:"MIS LYNX offers a wide range of prosthetics, reducing workflow complexity by streamlining the process and empowering flexible, efficient, and esthetic results."}        
        ]
    };
  },
  props: {
    sectionData:{}
  },
  computed: {
    ...mapGetters(["localeString"]),
    dataItems()
    {
      if(this.sectionData && this.sectionData.children.length>0)
      {
          return this.sectionData.children[0].files;
      }else{
          return this.testItems;
      }        
    },  
    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }
  },
  methods: 
  {
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    getDataNode()
    {
        this.sectionData.children[0];
    },
    getImgUrl(fileName)
    {
        if(fileName.indexOf("https://")>-1){
          return fileName;
        }else{
          return "https://mis-implants.com/upload"+fileName;          
        }
    },
    getTitle()
    {
        if(this.sectionData && this.sectionData.children.length>0)
        {
            return this.sectionData.children[0].sub_title;//this.getDataNode().sub_title;// "Section title";
        }else{
            return "MIS LYNX: NextGen Simplicity";
        }
    },
    getContent()
    {
        if(this.sectionData && this.sectionData.children.length>0)
        {
            return this.sectionData.children[0].summary;
            //return "Section content";
        }else{
            return "MIS LYNX is an all-in-one implant system that takes Simplicity to new heights. With single-use drills included with every implant, the MIS CLEAR™ wet surface, and a broad prosthetic range, MIS LYNX offers clinicians a reliable and valuable choice.";
        }

/*         <template v-else>
          <div>MIS LYNX: NextGen Simplicity</div>
          <p>MIS LYNX is an all-in-one implant system that takes Simplicity to new heights. With single-use drills included with every implant, the MIS CLEAR™ wet surface, and a broad prosthetic range, MIS LYNX offers clinicians a reliable and valuable choice.</p>
        </template>
 */
    }
  }
};
</script>

<style scoped>

    .proWhy4
    {
        width: 100%;
        min-height: 200px;
        /* background: #f6f6f6; */
        color: #fff;
        padding: 2vw 0vw;
        border-radius: 25px;
    }
    .proWhy4 .psTitle
    {
        color: #fff;
        width: 100%;
    }

    .topwhy
    {
      width: 100%;
      text-align: center;
    }
    .topwhy > h3
    {
      margin: auto;
      text-align: center;
      color: #202020;
      width: 60%;      
    }
    .topwhy > p
    {      
      color: #202020;
      width: 65%;
      margin: auto;
      padding-top: 16px;
    }

    .proWhy4 ul
    {
        padding-top: 50px;
        list-style: none; 
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 2vw;
    }
    .proWhy4 ul li
    {
        text-align:left;
        border-radius: 25px;
        background: #165D97;
        background: linear-gradient(0deg, rgba(22, 93, 151, 1) 0%, rgba(11, 58, 97, 1) 100%);        
    }
    .____proWhy4 ul li img
    {
        border-radius: 25px;
        height: 18vw;
        width: 100%;
        object-fit: cover;
        object-position: center bottom;
    }

    .proWhy4 ul li .scroll-thumb {
      width: 100%;
      height: 24vw;
      max-height: 24vw;
      overflow: hidden;
      position: relative;      
      border-radius: 14px;
      margin-bottom: 1vw;
    }
    .proWhy4 ul li .image-wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .proWhy4 ul li .scroll-thumb img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0px;
      /* left: -10%; */
      object-fit: cover;
      object-position: bottom center;
      will-change: transform;
    }    
    .wElementText
    {
      position: relative;
      top: -5vw;
    }

    .proWhy4 ul li > div
    {
      padding: 1.5vw 2.5vw 0 2.5vw;
    }
    .proWhy4 ul li h5
    {
        padding-top: 10px;
        font-size: var(--fsH1);
        line-height: var(--lhH1);        
        color: #fff;
        font-weight: 300 !important;
        width: 100% !important;
    }
    .proWhy4 ul li p
    {
        padding-top: 20px;
        color: #fff;
    }





    @media (hover: hover) {
    }

    @media screen and (max-width: 815px)
    {
        .proWhy4
        {
            padding: 5vw 0;
        }
        .proWhy4 ul
        {
            grid-template-columns: 1fr;

        }
        .topwhy > p,
        .topwhy > div{
          width: 100%;
          text-align: left;
        }
        .why-scrollbox
        {
          clip-path: inset(0%) !important; /* //remove scroll-clip-path effect on mobile */
        }


        .proWhy4 ul{
            grid-template-columns: repeat(1, 1fr);
            gap: 6vw;
        }
        .proWhy4 ul li .scroll-thumb {
            height: 64vw;
            max-height: 64vw;
        }        
        .proWhy4 ul li > div
        {
            padding: 1vw 10vw 4vw 10vw;
        }        

    }


    @media only screen and (min-width:2000px)
    {
    }
</style>
